import { Injectable, inject } from '@angular/core';
import { Storage, ref, uploadBytes, getDownloadURL, deleteObject } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private storage = inject(Storage);

  async uploadImage(file: File, path: string): Promise<string> {
    const storageRef = ref(this.storage, path);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }

  async uploadVideo(file: File, path: string): Promise<string> {
    const storageRef = ref(this.storage, path);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }

  async deleteFile(pathOrUrl: string): Promise<void> {
    try {
      // If a full download URL was passed, extract the storage path
      let objectPath = pathOrUrl;
      if (pathOrUrl.startsWith('http')) {
        // Expected pattern: https://firebasestorage.googleapis.com/v0/b/<bucket>/o/<ENCODED_PATH>?...
        const match = pathOrUrl.match(/\/o\/([^?]+)/);
        if (match && match[1]) {
          objectPath = decodeURIComponent(match[1]); // Decodes %2F into '/'
        } else {
          console.warn('Could not parse storage path from URL; aborting delete');
          return;
        }
      }
      const fileRef = ref(this.storage, objectPath);
      await deleteObject(fileRef);
    } catch (e) {
      console.warn('Failed to delete file', e);
    }
  }
}
